// extracted by mini-css-extract-plugin
export default {"tableHead":"TableHeadComponent_tableHead__63GJ0","tableHeadRow":"TableHeadComponent_tableHeadRow__zkmE2"};